import {Suspense} from 'react'
import {connect} from 'react-redux'

import {openDialog} from '../../../actions'
import {usePermission} from '../../../hooks/usePermission'
import type {State} from '../../../reducers/types'
import {getBuild, getBuildType, getIsSakuraUI, makeGetTagNames} from '../../../selectors'
import {Permission} from '../../../types'
import BuildTag from '../BuildTag/BuildTag'

import TagsList from './TagsList'
import type {ActionProps, OuterProps, OwnProps, StateProps} from './TagsList.types'

const mapStateToProps: () => (state: State, props: OwnProps) => StateProps = () => {
  const getTagNames = makeGetTagNames()
  return (state, {buildId}) => {
    const buildTypeId = getBuild(state, buildId)?.buildType
    return {
      buildTypeId,
      projectId: getBuildType(state, buildTypeId)?.projectId,
      tags: getTagNames(state, buildId),
      isSakuraUI: getIsSakuraUI(state),
    }
  }
}

const actionCreators: ActionProps = {openDialog}

function TagsListContainer(props: OuterProps) {
  const editable = usePermission(
    Permission.TAG_BUILD,
    props.isSakuraUI && props.withAddTags ? props.projectId : null,
  )

  return (
    <TagsList {...props} suppressLabel editable={editable}>
      {({tag, tagClasses, buildTypeId}) => (
        <BuildTag
          buildId={props.buildId}
          removable={editable}
          buildTypeId={buildTypeId}
          key={tag}
          label={tag}
          className={tagClasses}
        />
      )}
    </TagsList>
  )
}

export default connect(
  mapStateToProps,
  actionCreators,
)(function TagsListOuterContainer(props: OuterProps) {
  return (
    <Suspense>
      <TagsListContainer {...props} />
    </Suspense>
  )
})
